import { createAction } from 'redux-actions';
export const TOGGLE_REDEEM_MILES = 'TOGGLE_REDEEM_MILES';
export const SET_REDEEM_MILES = 'SET_REDEEM_MILES';
export const toggleRedeemMiles = createAction(TOGGLE_REDEEM_MILES);
export const setRedeemMiles = createAction(SET_REDEEM_MILES);
